import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

const API_BASE_URL = import.meta.env.VITE_SOOMER_API_URL || 'https://api.soomerlabs.com';
const APPLICATION_ID = import.meta.env.VITE_SOOMER_APPLICATION_ID || '';

interface LegalDocument {
  version: number;
  application: string;
  body: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
}

const TermsOfUse: React.FC = () => {
  const [document, setDocument] = useState<LegalDocument | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const formatEffectiveDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const response = await fetch(
          `${API_BASE_URL}/api/v1/terms-of-use/latest/`,
          {
            headers: {
              'X-Soomer-Application-ID': APPLICATION_ID,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch terms of use');
        }

        const data: LegalDocument = await response.json();
        setDocument(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setIsLoading(false);
      }
    };

    fetchDocument();
  }, []);

  return (
    <>
      <title>Terms of Use | Kline Real Estate Works</title>
      <meta name="description" content="Terms of Use for Kline Real Estate Works website." />

      <div className="page-content">
        <div className="container" style={{ maxWidth: '800px', padding: '4rem 1.5rem' }}>
          {isLoading ? (
            <div style={{ textAlign: 'center', padding: '4rem 0' }}>
              <p>Loading...</p>
            </div>
          ) : error ? (
            <div style={{ textAlign: 'center', padding: '4rem 0' }}>
              <p>Unable to load terms of use. Please try again later.</p>
            </div>
          ) : document ? (
            <>
              <div style={{ marginBottom: '2rem' }}>
                <h1>Terms of Use</h1>
                {document.created_at && (
                  <p style={{ color: 'var(--color-gray-600)', marginTop: '0.5rem' }}>
                    Effective Date: {formatEffectiveDate(document.created_at)}
                  </p>
                )}
              </div>
              <div className="legal-content">
                <ReactMarkdown>{document.body}</ReactMarkdown>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
